import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import './Oripa.css'
import NewOripaGeneral from './NewOripaGeneral'
import NewOripaSelectCard from './NewOripaSelectCard'
import NewOripaConfirm from './NewOripaConfirm'
import { useReducer } from 'react'

const NewOripa = () => {
  const [currentOripaPage, changeOripaPage] = useState(1);
  const [update, setUpdate] = useState(false)

  const moveNewOripaGeneralHandler = () => {
    changeOripaPage(1);
  }

  const moveNewOripaSelectCardHandler = () => {
    if (packageInfo.packageStatus === 1 || packageInfo.packageStatus === 6 || !packageInfo.packageStatus) {
      changeOripaPage(2);
    } else {
      changeOripaPage(3);
    }  
  }

  const moveNewOripaConfirmCancelHandler = () => {
    if (packageInfo.packageStatus === 1 || packageInfo.packageStatus === 6 || !packageInfo.packageStatus) {
      changeOripaPage(2);
    } else {
      changeOripaPage(1);
    }  
  }

  const moveNewOripaConfirmHandler = () => {
    changeOripaPage(3);
  }

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/package-master`, {
      method: 'GET',
      headers: {
        'X-XSRF-TOKEN': xsrfToken,
        'Authorization': `Bearer ${token}`
      },
      credentials: 'include'
    })
    .then(res => res.json())
    .then(data => {
      setPackageTypeList(data.package_type_masters);
    })
    .catch(err => {
      console.log(err);
    });
  }, []);

  useEffect(() => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
        xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
        token = token.split('=')[1]
    }
    fetch(process.env.REACT_APP_API_URL + '/api/shop', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
      },
      credentials: 'include',
    })
    .then(response => response.json())
    .then(data => {
      let shop = data.shop;
      setShopInfo({
        effectType: shop.effect_pattern ? shop.effect_pattern : 1,
        originalEffectPattern : shop.original_effect_pattern,
      })
    }).catch(error => {
      // window.location.href = '/' + shop;
    });
  }, [])

  const [shopInfo, setShopInfo] = useState({
    effectType: 1,
  });

  const [packageTypeList, setPackageTypeList] = useState([]);
  const [packageInfo, setPackageInfo] = useState({
    packageId: '',
    packageType: 1,
    packageName: '',
    packagePrice: '',
    packageNumber: '',
    packageStartAt: '',
    packageEndAt: '',
    packageImage: '',
    packageHiddenFrom: '',
    packagePopImage: '',
    effectType: "",
    packagePriority: 100,
    limitedNumberPerUser: "",
    limitedNumberPerUserPerDay: "",
    maxNumberPerOneDraw: 10,
    dependsOnHoldPoints: false,
    isEnabledAllDraw: true,
  });

  const {id} = useParams();

  useEffect(() => {
    if (!id) {
      setPackageInfo({
        packageId: '',
        packageType: 1,
        packageName: '',
        packagePrice: '',
        packageNumber: '',
        packageStartAt: '',
        packageEndAt: '',
        packageImage: '',
        packageHiddenFrom: '',
        packagePopImage: '',
        effectType: "",
        packagePriority: 100,
        limitedNumberPerUser: "",
        limitedNumberPerUserPerDay: "",
        maxNumberPerOneDraw: 10,
        dependsOnHoldPoints: false,
        isEnabledAllDraw: true,
      });
    }
  }, [id]);

  const [cardNumber, setCardNumber] = useState(0);
  const [cardList, setCardList] = useState([]);

  return (
    <>
      {currentOripaPage === 1 && <NewOripaGeneral moveNewOripaSelectCard={moveNewOripaSelectCardHandler} packageTypeList={packageTypeList} packageInfo={packageInfo} setPackageInfo={setPackageInfo} shopInfo={shopInfo}/>}
      {currentOripaPage === 2 && <NewOripaSelectCard moveNewOripaConfirm={moveNewOripaConfirmHandler} moveNewOripaGeneral={moveNewOripaGeneralHandler} packageInfo={packageInfo} setPackageInfo={setPackageInfo} cardNumber={cardNumber} setCardNumber={setCardNumber} cardList={cardList} setCardList={setCardList} />}
      {currentOripaPage === 3 && <NewOripaConfirm moveNewOripaSelectCard={moveNewOripaSelectCardHandler} moveNewOripaConfirmCancelHandler={moveNewOripaConfirmCancelHandler} packageInfo={packageInfo} packageTypeList={packageTypeList} setPackageInfo={setPackageInfo} cardNumber={cardNumber} setCardNumber={setCardNumber} cardList={cardList} setCardList={setCardList} />}
    </>
  );
}

export default NewOripa